document.addEventListener('submit', function (e) {
  const form = e.target.closest('.spotlight-card__form');
  if (!form) return;

  e.preventDefault();

  const button = form.querySelector('.spotlight-card__add-to-cart');
  if (!button || button.disabled) return;

  const cartNotification =
    document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const formData = new FormData(form);

  if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
    formData.append(
      'sections',
      cartNotification.getSectionsToRender().map(function (s) { return s.id; }).join(',')
    );
    formData.append('sections_url', window.location.pathname);
    if (typeof cartNotification.setActiveElement === 'function') {
      cartNotification.setActiveElement(document.activeElement);
    }
  }

  button.classList.add('spotlight-card__add-to-cart--loading');
  button.disabled = true;

  fetch(window.routes ? window.routes.cart_add_url : '/cart/add', {
    method: 'POST',
    headers: {
      Accept: 'application/javascript',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData,
  })
    .then(function (response) { return response.json(); })
    .then(function (response) {
      button.classList.remove('spotlight-card__add-to-cart--loading');

      if (response.status) {
        console.error('Cart error:', response.errors || response.description || response.message);
        button.disabled = false;
        return;
      }

      button.classList.add('spotlight-card__add-to-cart--success');
      setTimeout(function () {
        button.classList.remove('spotlight-card__add-to-cart--success');
        button.disabled = false;
      }, 2000);

      if (cartNotification && typeof cartNotification.renderContents === 'function') {
        const notificationEl = cartNotification.notification;
        if (notificationEl && !notificationEl.__skjFocusPatched) {
          const origFocus = notificationEl.focus.bind(notificationEl);
          notificationEl.focus = function (options) {
            return origFocus(Object.assign({ preventScroll: true }, options || {}));
          };
          notificationEl.__skjFocusPatched = true;
        }

        const scrollY = window.scrollY;
        cartNotification.renderContents(response);
        requestAnimationFrame(function () { window.scrollTo({ top: scrollY, behavior: 'instant' }); });
      }
    })
    .catch(function (err) {
      console.error(err);
      button.classList.remove('spotlight-card__add-to-cart--loading');
      button.disabled = false;
    });
});
